import { render, staticRenderFns } from "./MultipleAnswerResponse.vue?vue&type=template&id=24043c80&"
import script from "./MultipleAnswerResponse.vue?vue&type=script&lang=ts&"
export * from "./MultipleAnswerResponse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports